import {action, observable, runInAction} from 'mobx'
import GenericFormStore from '../../../stores/FormStore'
import userStore from "../../../stores/UserStore";
import {go} from "../../../utils/navigationUtility";
import registrationStore from '../store';
import {events} from "../../../constants/enums";
import {customEvent} from "../../../utils/analyticsUtil";

class LoginStore extends GenericFormStore {
    @observable isAuthenticating = false;
    @observable form = this._init();
     _init = () => {
        return {
            fields: {
                email: {
                    value: '',
                    error: '',
                    rule: 'required|email'
                },
                password: {
                    value: '',
                    error: '',
                    rule: 'required|password'
                },
            },
            meta: {
                isValid: true,
                error: null,
            },
        };
    };

    @action setUsername = (username) => {
        this.form.fields.email.value = username;
    };

    @action login = async () => {
        let {fields} = this.form;
        this.isAuthenticating = true;
        customEvent(events.EmailLoginButtonClick);
        registrationStore.authenticating = true;
        try{
            await userStore.login(fields.email.value, fields.password.value);
            runInAction(()=>{
                this.isAuthenticating = false;
                registrationStore.authenticating = false;
                this.form = this._init();
                go('students/activity');
            })
        }catch(err){
            runInAction(()=> {
                this.form.meta.error = err.message;
                this.isAuthenticating = false;
                registrationStore.authenticating = false;
            });
        }
    }
}

const loginStore = new LoginStore();
export default loginStore;
